import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { hasPermission } from '../../../utils/Permissions'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'

function formatDate(val) {
    if (!val) return ''
    const d = String(val).slice(0, 10)
    const [y, m, day] = d.split('-')
    return `${day}/${m}/${y}`
}

const ClaimTestimonialIndex = ({ entries, offices, filters }) => {
    const { flash } = usePage().props
    const filterForm = useForm({ search: filters.search || '', office_id: filters.office_id || '' })
    const rows = entries.data || []

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <Col xs={12}><Breadcrumbs currentPath="admin/claims/testimonials" /></Col>
            <Col xs={12}>
                <div className="card card-flush">
                    <div className="card-header pt-7">
                        <h3 className="card-title fw-bold text-gray-800">Registros de videos</h3>
                        <div className="card-toolbar">
                            {hasPermission('claims.testimonials.create') && (
                            <Link href={route('claims.testimonials.create')} className="btn btn-sm btn-primary">
                                Agregar video
                            </Link>
                            )}
                        </div>
                    </div>
                    <div className="card-body pt-6">
                        <Form
                            onSubmit={(e) => { e.preventDefault(); filterForm.get(route('claims.testimonials.index'), { preserveState: true }) }}
                            className="d-flex flex-wrap align-items-end gap-3 mb-8"
                        >
                            <div style={{ minWidth: '180px' }}>
                                <Form.Label className="fs-7 fw-bold text-gray-600 mb-2">Oficina</Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={filterForm.data.office_id}
                                    onChange={(e) => filterForm.setData('office_id', e.target.value)}
                                >
                                    <option value="">Todas las oficinas</option>
                                    {offices.map((o) => <option key={o.id} value={o.id}>{o.nombre}</option>)}
                                </Form.Select>
                            </div>
                            <div className="flex-grow-1" style={{ minWidth: '200px', maxWidth: '320px' }}>
                                <Form.Label className="fs-7 fw-bold text-gray-600 mb-2">Nombre</Form.Label>
                                <Form.Control
                                    size="sm"
                                    placeholder="Buscar nombre..."
                                    value={filterForm.data.search}
                                    onChange={(e) => filterForm.setData('search', e.target.value)}
                                />
                            </div>
                            <Button type="submit" size="sm" variant="secondary">Filtrar</Button>
                        </Form>

                        <Table responsive striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Asegurado</th>
                                    <th>Fecha</th>
                                    <th>Oficina</th>
                                    <th>YouTube ID</th>
                                    <th>Registró</th>
                                    <th className="text-end" style={{ width: 100 }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.insured_name}</td>
                                        <td>{formatDate(row.video_date)}</td>
                                        <td>{row.office?.nombre}</td>
                                        <td>{row.youtube_video_id}</td>
                                        <td>{row.registered_by?.name}</td>
                                        <td className="text-end">
                                            {hasPermission('claims.testimonials.edit') && (
                                            <Link
                                                href={route('claims.testimonials.edit', row.id)}
                                                className="btn btn-sm btn-light-primary"
                                            >
                                                Editar
                                            </Link>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <PaginationList
                            links={entries.links}
                            filters={{ search: filters.search || undefined, office_id: filters.office_id || undefined }}
                        />
                    </div>
                </div>
            </Col>
        </Row>
    )
}

ClaimTestimonialIndex.layout = (page) => <Layout title="Videos siniestros">{page}</Layout>

export default ClaimTestimonialIndex
